import { FileSearch, FileText, ShieldCheck } from 'lucide-react';

import {
  BADGE_VALIDITY_MONTHS,
  REPORT_TURNAROUND_SHORT,
} from '@repo/contracts/services-pricing';

import { CONTACT_EMAIL, SAMPLE_REPORT_URL } from '../../content/site';
import { BadgePreview } from '../badge-preview';
import { Card, Container, SectionHeading } from '../ui';

const ITEMS = [
  {
    icon: FileSearch,
    points: ['Headline issues', 'Severity counts', 'Fixed quote and invoice'],
    title: 'Teaser',
    when: 'After scoping',
  },
  {
    icon: FileText,
    points: [
      'Every issue verified by a specialist',
      'Severity, WCAG criterion and element',
      'Screenshot and fix guidance',
    ],
    title: 'Full report',
    when: `${REPORT_TURNAROUND_SHORT} after payment`,
  },
  {
    icon: ShieldCheck,
    points: [
      'Links to a public verification page',
      'Shows domain, standard and date',
      `Valid for ${BADGE_VALIDITY_MONTHS} months`,
    ],
    title: 'Badge',
    when: 'With your report',
  },
];

export function Deliverables() {
  const monthYear = new Date().toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
  return (
    <section aria-labelledby="deliverables-title" className="py-24 md:py-32">
      <Container>
        <SectionHeading
          eyebrow="What you get"
          id="deliverables-title"
          title="A report your team can work from"
        />
        <ul className="mt-12 grid gap-4 lg:grid-cols-3">
          {ITEMS.map(({ icon: Icon, points, title, when }) => (
            <li key={title}>
              <Card className="flex h-full flex-col">
                <div className="flex items-center justify-between">
                  <Icon
                    aria-hidden
                    className="text-brand-strong"
                    size={24}
                    strokeWidth={1.5}
                  />
                  <span className="text-small-label uppercase text-text-secondary">
                    {when}
                  </span>
                </div>
                <h3 className="mt-4 text-card-title text-text-primary">
                  {title}
                </h3>
                <ul className="mt-4 space-y-2 text-body text-text-secondary">
                  {points.map((p) => (
                    <li key={p}>{p}</li>
                  ))}
                </ul>
                {title === 'Badge' ? (
                  <div className="mt-auto pt-6">
                    <BadgePreview
                      domain="example.com"
                      monthYear={monthYear}
                      standard="WCAG 2.2 AA"
                    />
                  </div>
                ) : null}
              </Card>
            </li>
          ))}
        </ul>
        <p className="mt-8 text-ui-lg">
          <a
            className="font-semibold text-text-primary underline underline-offset-4"
            href={
              SAMPLE_REPORT_URL ??
              `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent('Sample accessibility report')}`
            }
          >
            {SAMPLE_REPORT_URL
              ? 'Download a sample report (PDF)'
              : 'Email me a sample report'}
          </a>
        </p>
      </Container>
    </section>
  );
}
